// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3wa0j","main":"Loading_main__3gIL6","load":"Loading_load__1Dq_s"};